import React, { useState } from "react";
import ModalBase from "./ModalBase";
import { Box, IconButton, Tooltip } from "@mui/material";
import GroupBase from "../../../pages/group/GroupBase";
import { GroupType } from "../../../types/group.type";
import { LuEye } from "react-icons/lu";

interface IModalDetailId {
  group: GroupType;
}

function ModalDetailId({ group }: IModalDetailId) {
  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {open && (
        <ModalBase
          title="Chi tiết kết quả"
          width="1200px"
          open={open}
          handleClose={handleClose}
        >
          <Box>
            <GroupBase
              group={group}
              fixedHeaderScrollHeight="60vh"
              wrapperHeight="60vh"
            />
          </Box>
        </ModalBase>
      )}
      {/* Button */}
      <Tooltip placement="top" arrow title="Xem chi tiết">
        <IconButton onClick={() => setOpen(true)}>
          <LuEye size={20} />
        </IconButton>
      </Tooltip>
    </>
  );
}

export default ModalDetailId;
